import axios from "axios";
import store from "../store";

const BASE = () => `${process.env.VUE_APP_SAAS_BACK}/config`;
const headers = () => ({ Authorization: "Bearer " + store.state.jwt });

class ConfigService {
    async save(name, version, type, data, scope = "personal", context = null) {
        const res = await axios.post(BASE() + "/save", { name, version, type, data, scope, context }, { headers: headers() });
        return res.data;
    }

    async list(type = null, context = null) {
        const res = await axios.post(BASE() + "/list", { type, context }, { headers: headers() });
        return res.data;
    }

    async load(uid) {
        const res = await axios.post(BASE() + "/load", { uid }, { headers: headers() });
        return res.data;
    }

    async rename(uid, new_name) {
        const res = await axios.post(BASE() + "/rename", { uid, new_name }, { headers: headers() });
        return res.data;
    }

    async delete(uid) {
        const res = await axios.post(BASE() + "/delete", { uid }, { headers: headers() });
        return res.data;
    }

    async setShared(uid, shared) {
        const res = await axios.post(BASE() + "/set_shared", { uid, shared }, { headers: headers() });
        return res.data;
    }

    async versions(uid) {
        const res = await axios.post(BASE() + "/versions", { uid }, { headers: headers() });
        return res.data;
    }

    async restore(uid) {
        const res = await axios.post(BASE() + "/restore", { uid }, { headers: headers() });
        return res.data;
    }

    async deleteOne(uid) {
        const res = await axios.post(BASE() + "/delete_one", { uid }, { headers: headers() });
        return res.data;
    }

    async setDefault(uid, is_default) {
        const res = await axios.post(BASE() + "/set_default", { uid, is_default }, { headers: headers() });
        return res.data;
    }

    async loadDefault(type, context = null) {
        const res = await axios.post(BASE() + "/load_default", { type, context }, { headers: headers() });
        return res.data;
    }
}

export default new ConfigService();
